import React from 'react';
import './svg.css';

const HMCIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1184_1268)">
        <path
          d="M10.5007 18.3166C14.8729 18.3166 18.4173 14.7722 18.4173 10.3999C18.4173 6.02769 14.8729 2.48328 10.5007 2.48328C6.1284 2.48328 2.58398 6.02769 2.58398 10.3999C2.58398 14.7722 6.1284 18.3166 10.5007 18.3166Z"
          fill="#08081B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5003 2.88337C6.34892 2.88337 2.98359 6.2487 2.98359 10.4C2.98359 14.5514 6.34892 17.9167 10.5003 17.9167C14.6516 17.9167 18.0169 14.5514 18.0169 10.4C18.0169 6.2487 14.6516 2.88337 10.5003 2.88337ZM2.18359 10.4C2.18359 5.80687 5.90709 2.08337 10.5003 2.08337C15.0934 2.08337 18.8169 5.80687 18.8169 10.4C18.8169 14.9932 15.0934 18.7167 10.5003 18.7167C5.90709 18.7167 2.18359 14.9932 2.18359 10.4Z"
          fill="#141827"
        />
        <path
          d="M8.4043 7.72195C8.4043 7.72195 8.68867 6.20007 10.5001 6.20841C12.3116 6.21674 12.9241 8.43966 11.9689 9.41153C11.5418 9.84799 11.1762 10.2074 10.9168 10.4595C10.7848 10.59 10.68 10.7454 10.6085 10.9167C10.5369 11.088 10.5001 11.2717 10.5001 11.4574V12.2626"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5009 14.7584C10.6068 14.7584 10.6926 14.6726 10.6926 14.5667C10.6926 14.4609 10.6068 14.375 10.5009 14.375C10.3951 14.375 10.3092 14.4609 10.3092 14.5667C10.3092 14.6726 10.3951 14.7584 10.5009 14.7584ZM9.89258 14.5667C9.89258 14.2307 10.1649 13.9584 10.5009 13.9584C10.8369 13.9584 11.1092 14.2307 11.1092 14.5667C11.1092 14.9027 10.8369 15.175 10.5009 15.175C10.1649 15.175 9.89258 14.9027 9.89258 14.5667Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5003 14.8625C10.6636 14.8625 10.7961 14.73 10.7961 14.5667C10.7961 14.4033 10.6636 14.2708 10.5003 14.2708C10.3369 14.2708 10.2044 14.4033 10.2044 14.5667C10.2044 14.73 10.3369 14.8625 10.5003 14.8625ZM9.99609 14.5667C9.99609 14.2882 10.2218 14.0625 10.5003 14.0625C10.7787 14.0625 11.0044 14.2882 11.0044 14.5667C11.0044 14.8451 10.7787 15.0708 10.5003 15.0708C10.2218 15.0708 9.99609 14.8451 9.99609 14.5667Z"
          fill="white"
        />
        <path
          d="M10.5 15.1917C10.8452 15.1917 11.125 14.9118 11.125 14.5667C11.125 14.2215 10.8452 13.9417 10.5 13.9417C10.1548 13.9417 9.875 14.2215 9.875 14.5667C9.875 14.9118 10.1548 15.1917 10.5 15.1917Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5 14.3917C10.4034 14.3917 10.325 14.47 10.325 14.5667C10.325 14.6633 10.4034 14.7417 10.5 14.7417C10.5966 14.7417 10.675 14.6633 10.675 14.5667C10.675 14.47 10.5966 14.3917 10.5 14.3917ZM11.125 14.5667C11.125 14.9118 10.8452 15.1917 10.5 15.1917C10.1548 15.1917 9.875 14.9118 9.875 14.5667C9.875 14.2215 10.1548 13.9417 10.5 13.9417C10.8452 13.9417 11.125 14.2215 11.125 14.5667Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1184_1268">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5 0.400024)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HMCIcon;
